<template>
  <div class="search-results">
    <Header />

    <div class="container">
      <!-- هدر جستجو -->
      <div class="search-header">
        <h1>نتایج جستجو برای: "{{ $route.query.q }}"</h1>
        <p class="results-count">{{ totalResults }} نتیجه پیدا شد</p>
      </div>

      <!-- نتایج -->
      <div class="results-grid">
        <!-- اخبار -->
        <div class="results-section">
          <h2>اخبار</h2>
          <div v-if="newsResults.length" class="news-results">
            <div
                v-for="news in newsResults"
                :key="news.id"
                class="news-result-item"
                @click="$router.push({ name: 'NewsDetail', params: { slug: news.id + '-' + this.slugify(news.title) } })"
            >
              <h3>{{ news.title }}</h3>
              <p>{{ news.summary }}</p>
              <span class="result-meta">{{ news.category }} • {{ formatDate(news.publishDate) }}</span>
            </div>
          </div>
          <div v-else class="no-results">
            هیچ خبری پیدا نشد
          </div>
        </div>

        <!-- مسابقات -->
        <div class="results-section">
          <h2>مسابقات</h2>
          <div v-if="matchResults.length" class="match-results">
            <div
                v-for="match in matchResults"
                :key="match.id"
                class="match-result-item"
            >
              <div class="teams">
                <span class="team">{{ match.team1?.name }}</span>
                <span class="vs">vs</span>
                <span class="team">{{ match.team2?.name }}</span>
              </div>
              <div class="match-info">
                <span class="league">{{ match.league?.name }}</span>
                <span class="score">{{ match.score || '--' }}</span>
              </div>
            </div>
          </div>
          <div v-else class="no-results">
            هیچ مسابقه‌ای پیدا نشد
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../services/api'

export default {
  name: 'SearchResults',
  data() {
    return {
      newsResults: [],
      matchResults: [],
      loading: false
    }
  },
  computed: {
    totalResults() {
      return this.newsResults.length + this.matchResults.length
    }
  },
  methods: {
    slugify(title) {
      if (!title) return ''
      return title
          .trim()
          .replace(/\u200c|\u200b|\u200d|\ufeff/g, '-')
          .replace(/[,;:.!?"'()]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '')
    },
    async performSearch() {
      const query = this.$route.query.q
      if (!query) return

      this.loading = true

      try {
        // جستجو در اخبار
        const allNews = await apiService.getNews()
        this.newsResults = allNews.filter(news =>
            news.title.toLowerCase().includes(query.toLowerCase()) ||
            news.summary.toLowerCase().includes(query.toLowerCase())
        )

        // جستجو در مسابقات
        const allMatches = await apiService.getMatches()
        this.matchResults = allMatches.filter(match =>
            match.team1?.name.toLowerCase().includes(query.toLowerCase()) ||
            match.team2?.name.toLowerCase().includes(query.toLowerCase()) ||
            match.league?.name.toLowerCase().includes(query.toLowerCase())
        )
      } catch (error) {
        console.error('Search error:', error)
      } finally {
        this.loading = false
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('fa-IR')
    }
  },
  watch: {
    '$route.query.q': {
      immediate: true,
      handler() {
        this.performSearch()
      }
    }
  }
}
</script>

<style scoped>
.search-results {
  min-height: 100vh;
  background: #f5f7f9;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.search-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 30px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.search-header h1 {
  color: #1e3a8a;
  margin-bottom: 10px;
}

.results-count {
  color: #6b7280;
  font-size: 1.1rem;
}

.results-grid {
  display: grid;
  gap: 30px;
}

.results-section {
  background: white;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.results-section h2 {
  color: #1e3a8a;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e5e7eb;
}

.news-result-item {
  padding: 15px;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  transition: background 0.3s;
}

.news-result-item:hover {
  background: #f8fafc;
}

.news-result-item:last-child {
  border-bottom: none;
}

.news-result-item h3 {
  color: #1f2937;
  margin-bottom: 8px;
}

.news-result-item p {
  color: #6b7280;
  margin-bottom: 8px;
  line-height: 1.5;
}

.result-meta {
  font-size: 0.8rem;
  color: #9ca3af;
}

.match-result-item {
  padding: 15px;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.match-result-item:last-child {
  border-bottom: none;
}

.teams {
  display: flex;
  align-items: center;
  gap: 10px;
}

.team {
  font-weight: 500;
}

.vs {
  color: #9ca3af;
  font-size: 0.9rem;
}

.match-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
}

.league {
  font-size: 0.8rem;
  color: #6b7280;
}

.score {
  font-weight: bold;
  color: #1e3a8a;
}

.no-results {
  text-align: center;
  color: #9ca3af;
  padding: 40px;
  font-style: italic;
}

/* موبایل */
@media (max-width: 768px) {
  .container {
    padding: 10px;
  }

  .search-header {
    padding: 20px;
    margin-bottom: 20px;
  }

  .results-section {
    padding: 15px;
  }

  .match-result-item {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .match-info {
    align-items: flex-start;
  }
}
</style>